import React from 'react';
export function EmotionSection() {
  const benefits = [{
    title: 'Sun damage, reversed.',
    description: 'Years of exposure faded in a single session. Watch hyperpigmentation and sun spots lift away, revealing an even, flawless canvas.'
  }, {
    title: 'Pores, practically invisible.',
    description: "Texture smoothed from the inside out. By stimulating deep collagen production, your skin's surface becomes remarkably refined."
  }, {
    title: 'The glow people ask you about.',
    description: "That 'you look amazing, what are you doing?' reaction. Achieve a lit-from-within radiance that makeup simply cannot replicate."
  }];
  return <section className="py-24 md:py-32 bg-background" data-id="element-66">
      <div className="container mx-auto px-4 md:px-8" data-id="element-67">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24" data-id="element-68">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-foreground leading-tight" data-id="element-69">
            You won't look different. <br className="hidden md:block" data-id="element-70" />
            <span className="italic text-foreground/80" data-id="element-71">
              You'll look like you — at your best.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 max-w-6xl mx-auto" data-id="element-72">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-73">
              <span className="text-gold text-2xl mb-6 transform transition-transform group-hover:scale-125 duration-300" data-id="element-74">
                ✦
              </span>
              <h3 className="text-xl font-serif text-foreground mb-4" data-id="element-75">
                {benefit.title}
              </h3>
              <p className="text-foreground/70 font-sans leading-relaxed" data-id="element-76">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}